import personal from '@/views/personal/index';
import personalDetail from '@/views/personalDetail/index';

const personalRouter = [
    {
        path: '/personal',
        component: personal,
        children: [
            {
                path: '',
                component: () => import('@/views/personal/personal'),
                name: 'personalIndex',
                meta: { title: '个人中心', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'myOrder',
                component: () => import('@/views/personal/order/myOrder'),
                name: 'myOrder',
                meta: { title: '我的订单', icon: '', affix: true, requireAuth: true }
            },
            {
                path:'sampleOrder',
                component: () => import('@/views/personal/sample/sampleOrder'),
                name: 'myOrder',
                meta: { title: '我的样品单', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'invoice',
                component: () => import('@/views/personal/invoice'),
                name: 'invoice',
                meta: { title: '开票资料', icon: '', affix: true , requireAuth: true}
            },
            {
                path: 'Remittance',
                component: () => import('@/views/personal/Remittance'),
                name: 'Remittance',
                meta: { title: '专属汇款账户', icon: '', affix: true , requireAuth: true}
            },
            {
                path: 'DeliveryList',
                component: () => import('@/views/personal/DeliveryList'),
                name: 'DeliveryList',
                meta: { title: '我的送货单', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'backGoods',
                component: () => import('@/views/personal/returned/backGoods'),
                name: 'backGoods',
                meta: { title: '我的退货', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'accountStatement',
                component: () => import('@/views/personal/account_statement'),
                name: 'accountStatement',
                meta: { title: '我的对账单', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'accountInfo',
                component: () => import('@/views/personal/account_information'),
                name: 'accountInfo',
                meta: { title: '账户信息', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'collection_list',
                component: () => import('@/views/personal/collection_list'),
                name: 'collection_list',
                meta: { title: '我的收藏', icon: '', affix: true, requireAuth: true , type:1}
            },
            {
                path: 'enterprise',
                component: () => import('@/views/personal/enterprise'),
                name: 'enterprise',
                meta: { title: '企业设置', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'purchaseRecord',
                component: () => import('@/views/personal/purchase_record'),
                name: 'purchaseRecord',
                meta: { title: '购买记录', icon: '', affix: true, requireAuth: true , type:2}
            },
            {
                path: 'receivingAddress',
                component: () => import('@/views/personal/receiving_address'),
                name: 'receivingAddress',
                meta: { title: '收货地址', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'suggest',
                component: () => import('@/views/personal/suggest'),
                name: 'suggest',
                meta: { title: '建议反馈', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'subAccount',
                component: () => import('@/views/personal/subAccount'),
                name: 'subAccount',
                meta: { title: '子账号管理', icon: '', affix: true, requireAuth: true }
            }
        ]
    },
    {
        path: '/personalDetail',
        component: personalDetail,
        children: [
            {
                path: 'orderDetail',
                component: () => import('@/views/personal/order/myOrderDetail'),
                name: 'orderDetail',
                meta: { title: '我的订单详情', icon: '', affix: true, requireAuth: true }
            },
            {
                path: '/personalDetail/deliveryDetail',
                component: () => import('@/views/personalDetail/deliveryDetail'),
                name: 'deliveryDetail',
                meta: { title: '送货单详情', icon: '', affix: true, requireAuth: true }
            },
            {
                path: '/personalDetail/returnGoods',
                component: () => import('@/views/personal/returned/returnGoods'),
                name: 'returnGoods',
                meta: { title: '退货申请', icon: '', affix: true, requireAuth: true }
            },
            {
                path: '/personalDetail/statementDetails',
                component: () => import('@/views/personalDetail/statement_details'),
                name: 'statementDetails',
                meta: { title: '我的对账单详情', icon: '', affix: true, requireAuth: true }
            },
            {
                path: '/personalDetail/backDetail',
                component: () => import('@/views/personal/returned/back_detail'),
                name: 'backDetail',
                meta: { title: '退货详情', icon: '', affix: true, requireAuth: true }
            },
            {
                path: '/personalDetail/modifyMobile',
                component: () => import('@/views/personalDetail/modifyMobile'),
                name: 'modifyMobile',
                meta: { title: '修改手机号', icon: '', affix: true, requireAuth: true }
            },
            {
                path: '/personalDetail/modifyPassword',
                component: () => import('@/views/personalDetail/modifyPassword'),
                name: 'modifyPassword',
                meta: { title: '修改密码', icon: '', affix: true, requireAuth: true }
            },

        ]
    }
]

export default personalRouter;



// WEBPACK FOOTER //
// ./src/router/modules/personalRouter.js